// Единственная точка импорта @aseller/host-contract во всём модуле.
// Смысл: контракт с платформой поднимают версиями, и при апгрейде меняется
// один файл, а не двадцать импортов по дереву. Прямой импорт пакета где-либо
// ещё — регрессия этого правила.
//
// Ровно одно исключение: `shared/api/apiUrl.ts` берёт оттуда `resolveRemoteApiBase`.
// Импортировать его через этот файл нельзя — слой `shared` не имеет права знать о
// слое `app` (STRUCTURE.md), а база API нужна именно в транспорте. Исключение
// названо здесь, чтобы оно оставалось одним, а не превратилось в практику.

import { mapHostLanguage, type HostLanguage } from '@aseller/host-contract';
import type { AppLocale } from '../shared/i18n';

export type {
  HostContext,
  HostContextUser,
  HostEntry,
  HostLanguage,
  HostModalSize,
  HostTheme,
  RemoteModule,
} from '@aseller/host-contract';

export {
  CONTRACT_VERSION,
  createRemote,
  createMockContext,
  HostProvider,
  mapHostLanguage,
  mapPlatformRole,
  PlatformRole,
  useHost,
} from '@aseller/host-contract';

// Платформа кодирует украинский как 'ua', наши бандлы — как 'uk'; на 'zh'
// переводов нет вовсе. mapHostLanguage сужает union хоста до того, что мы правда
// переводим, а таблица ниже переводит код платформы в код бандла.
const HOST_LANGUAGES_WE_TRANSLATE = ['en', 'ru', 'ua'] as const;

const HOST_LANGUAGE_TO_LOCALE: Record<(typeof HOST_LANGUAGES_WE_TRANSLATE)[number], AppLocale> = {
  en: 'en',
  ru: 'ru',
  ua: 'uk',
};

// Фолбэк — 'en', а не язык standalone-режима: в embed язык задаёт платформа, и
// для непереведённого языка хоста нейтральнее английский, совпадающий с
// fallbackLng инстанса i18n.
export function resolveEmbedLocale(language: HostLanguage): AppLocale {
  return HOST_LANGUAGE_TO_LOCALE[mapHostLanguage(language, HOST_LANGUAGES_WE_TRANSLATE, 'en')];
}
